var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    },
    [
      _c("div", { staticClass: "fixed inset-0 transition-opacity" }, [
        _c("div", {
          staticClass: "absolute inset-0 bg-gray-500 opacity-75",
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        {
          staticClass:
            "relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-headline"
          }
        },
        [
          _vm._m(0),
          _c("div", { staticClass: "sm:ml-4 mt-4" }, [
            _vm.showCSVError
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bg-yellow-50 border-l-4 border-yellow-400 p-4 my-4"
                  },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c("div", { staticClass: "flex-shrink-0" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5 text-yellow-400",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d:
                                  "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._m(1)
                    ])
                  ]
                )
              : _vm._e(),
            _vm.showLimitWarning
              ? _c(
                  "div",
                  {
                    staticClass:
                      "bg-yellow-50 border-l-4 border-yellow-400 p-4 my-4"
                  },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c("div", { staticClass: "flex-shrink-0" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5 text-yellow-400",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d:
                                  "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._m(2)
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "email" }
                },
                [_vm._v(" Name ")]
              ),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name"
                    }
                  ],
                  ref: "name",
                  staticClass:
                    "bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal",
                  attrs: { type: "text", placeholder: "Flash sale campaign" },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "name", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "mt-4" }, [
              _vm._m(3),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.templateId,
                        expression: "form.templateId"
                      }
                    ],
                    staticClass:
                      "mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                    attrs: { id: "location" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "templateId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.templates, function(template, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: template.elementName } },
                      [_vm._v(_vm._s(template.name))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _c("div", { staticClass: "mt-4" }, [
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("div", { staticClass: "sm:col-span-6" }, [
                  _c(
                    "label",
                    {
                      staticClass: "block text-sm font-medium text-gray-700",
                      attrs: { for: "cover-photo" }
                    },
                    [_vm._v(" Import Customers from shopify ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                    },
                    [
                      _c("div", { staticClass: "space-y-1 text-center" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "mx-auto h-12 w-12 text-gray-400",
                            attrs: {
                              stroke: "currentColor",
                              fill: "none",
                              viewBox: "0 0 48 48",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex text-sm text-gray-600 justify-center"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500",
                                attrs: { for: "file-upload" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Upload Customer CSV file")
                                ]),
                                _c("input", {
                                  staticClass: "sr-only",
                                  attrs: {
                                    id: "file-upload",
                                    name: "file-upload",
                                    type: "file",
                                    accept: ".csv"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.processFile($event)
                                    }
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-xs text-gray-500 hover:underline",
                            attrs: {
                              href:
                                "https://help.shopify.com/en/manual/customers/import-export-customers",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              " Learn how to export Customer csv from shopify "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm.form.phoneNumbers.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex my-4 justify-center flex-col" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "block text-sm font-medium text-gray-700"
                        },
                        [_vm._v(" Messages will be sent to these numbers ")]
                      ),
                      _c("textarea", {
                        staticClass:
                          "max-w-lg shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md bg-gray-200 cursor-not-allowed p-4",
                        attrs: { rows: "3", disabled: "" },
                        domProps: {
                          value: _vm.getPhoneNumbers(_vm.form.phoneNumbers)
                        }
                      })
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _c(
            "div",
            { staticClass: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-75",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.$v.form.$invalid || _vm.buttonLoaders.isCreating
                      },
                      on: { click: _vm.onCreate }
                    },
                    [_vm._v(" Send ")]
                  )
                ]
              ),
              _c(
                "span",
                {
                  staticClass:
                    "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                      attrs: { type: "button" },
                      on: { click: _vm.close }
                    },
                    [_vm._v(" Cancel ")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm:flex sm:items-start" }, [
      _c(
        "div",
        { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
        [
          _c(
            "h3",
            {
              staticClass: "text-lg leading-6 font-medium text-gray-900",
              attrs: { id: "modal-headline" }
            },
            [_vm._v(" Create Campaign ")]
          ),
          _c("div", { staticClass: "mt-2" })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-3" }, [
      _c("p", { staticClass: "text-sm text-yellow-700" }, [
        _vm._v(
          " We are unabled to parse the CSV. Please upload the proper CSV file (exported from shopify) "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-3" }, [
      _c("p", { staticClass: "text-sm text-yellow-700" }, [
        _vm._v(
          " Whatsapp recommends to send not more than 1000 messages in a day with their API. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "block text-sm font-medium leading-5 text-gray-700",
        attrs: { for: "email" }
      },
      [
        _c("div", { staticClass: "flex justify-between items-center my-2" }, [
          _c("span", [_vm._v("Template")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }